import {getDataWithPromise, Globals, handleAjaxError } from "./BaseDataFns";

export const getSchool = ( school_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/schools/' + school_id + '?include-attendance-officer&include-teachers&include-pupils&include-attendance-officers&include-groups';

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getSchoolsInGroup = ( school_group_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/schoolgroups/' + school_group_id + '/schools' ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateSchoolDetails = ( school_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + '/schools/' + school_id ;

    getDataWithPromise ( url, 'PUT', {data} )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const createSchool = ( data, onComplete ) =>
{
    const url = Globals.APIFolder + '/schools' ;

    getDataWithPromise ( url, 'POST', {data} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getProviderCompletionDetails = ( academic_year, survey_type, submission_status, onComplete ) =>
{
    const url = Globals.APIFolder + '/statistics/completion/' + academic_year + '/details?survey_type=' + survey_type + '&submission_status=' + submission_status;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}




